export const PAYPAL_CONFIG = {
  clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID,
  currency: "USD",
  intent: "capture",
  components: "buttons",
  disableFunding: "credit,card"
};

export const MEMBERSHIP_PRICES = {
  individual: 40.00,
  family: 60.00,
  senior: 20.00,
  lifetime: 200.00
};

export const EVENT_PRICES = {
  member: 45.00,
  nonMember: 60.00,
  guest: 60.00
}; 